import { useEffect, useState } from 'react'
import Modal from '..'
import ModalClose from '../ModalClose'
import { IDisableStaffModal } from '../../../interfaces/staff'
import { IoWarningOutline } from 'react-icons/io5'
import { showToast } from '../../../utils/toast'
import EstateService from '../../../api/estate-service'
import { handleErrorResponse } from '../../../utils/handleErrorResponse'

const DisableStaffModal = ({
  open,
  setIsOpen,
  staffId,
  initialStatus,
  reload,
}: IDisableStaffModal) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isActive, setIsActive] = useState(initialStatus)

  useEffect(() => {
    setIsActive(initialStatus)
  }, [initialStatus])

  const handleToggleClick = async () => {
    if (isLoading) return

    const action = isActive ? 'disable' : 'enable'
    setIsLoading(true)

    try {
      const response = await EstateService.disableOrEnableStaff(staffId, action)
      if (response.success) {
        showToast({
          title: `Staff ${action === 'enable' ? 'Enabled' : 'Disabled'}`,
          description: `The staff member has been ${action === 'enable' ? 'enabled' : 'disabled'} successfully.`,
          status: 'success',
        })

        setIsActive(!isActive)
        setIsOpen(false)
        reload()
      } else {
        showToast({
          title: 'Error',
          description: `Failed to ${action} staff. Please try again.`,
          status: 'error',
        })
      }
    } catch (error: any) {
    handleErrorResponse(error, `staff-${staffId}-${action}-error`)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal open={open} close={() => setIsOpen(false)} modalClassName="flex flex-col">
      <ModalClose onClick={() => setIsOpen(false)} />
      <div className="flex flex-col items-center text-center">
        <IoWarningOutline
          className={`text-5xl sm:text-6xl ${isActive ? 'text-red-600' : 'text-green-600'}`}
        />
        <h2
          className={`text-lg sm:text-2xl font-semibold mb-4 ${isActive ? 'text-red-600' : 'text-green-600'}`}
        >
          {isActive ? 'Disable' : 'Enable'} Staff
        </h2>
      </div>
      <div className="px-2">
        <p className="text-xs sm:text-sm text-gray-600 text-center">
          Do you want to {isActive ? 'disable' : 'enable'} this staff? This action cannot
          be undone.
        </p>
      </div>
      <div className="flex justify-center sm:justify-end my-8 sm:my-10">
        <button
          type="button"
          className="w-full sm:w-40 h-9 text-white text-sm sm:text-base font-medium bg-black cursor-pointer rounded-lg border-none transition-colors disabled:cursor-not-allowed disabled:opacity-100 disabled:transform-none disabled:shadow-none disabled:bg-gray-400 enabled:hover:bg-gray-700"
          onClick={handleToggleClick}
          disabled={isLoading}
        >
          {isLoading
            ? isActive
              ? 'Disabling...'
              : 'Enabling...'
            : isActive
              ? 'Disable'
              : 'Enable'}
        </button>
      </div>
    </Modal>
  )
}

export default DisableStaffModal
